import { DocumentDuplicateIcon } from "@heroicons/react/24/outline";

const TicketPrint = [
    {
        path: "ticket-print",
        fullPath: "ticket/ticket-print",
        exact: true,
        showChildren: false,
        sidebarMenu: true,
        displayName: "Ticket Print Info",
        displayPath: "Ticket > Ticket Print Info",
        icon: DocumentDuplicateIcon,
        children: [
            {
                index: true,
                async lazy() {
                    const component = await import(
                        "../../pages/Ticket/TicketPrint/List"
                    );
                    return {
                        Component: component.default,
                    };
                },
                permissions: ["ticket-print-list"],
            },
            {
                path: "create",
                async lazy() {
                    const component = await import(
                        "../../pages/Ticket/TicketPrint/Upsert"
                    );
                    return {
                        Component: component.default,
                    };
                },
                exact: true,
                permissions: ["ticket-print-create"],
            },
            {
                path: "edit/:id",
                async lazy() {
                    const component = await import(
                        "../../pages/Ticket/TicketPrint/Upsert"
                    );
                    return {
                        Component: component.default,
                    };
                },
                exact: true,
                permissions: ["ticket-print-edit"],
            },
        ],
    },
];

export default TicketPrint;
